// The result colours the Learn exercises share (issues #3473, #3518), from the "Rhythm Echo
// (result)" and "Session summary" artboards on the design canvas. The app has no success/warning/
// error trio (--color-warning is a different yellow and there is no error colour), so the three
// live here as constants; they stay the same in dark mode, like --color-checkmark-song, which
// happens to be the same green.

// One square on a session summary, and one beat or pattern on a rhythm result
export type SquareColor = 'green' | 'yellow' | 'red';

export const resultColorCss: Record<SquareColor, string> = {
  green: '#4dc502', // on time, or the note was matched
  yellow: '#f5b800', // early or late
  red: '#e0342c', // missed
};
